<div class="info-chip-container" [ngClass]="customClass">
    <img *ngIf="imgUrl !== ''" src="{{imgUrl}}">
    <mat-icon *ngIf="icon !== ''">{{icon}}</mat-icon>
    <p>{{textChip}}</p>
</div>